import React, { FC } from 'react';
import { Text } from '@blueprint/ui';
import alertModalTranslations from 'public/locales/en/search.json';
import { getTranslator } from '../../i18n/getTranslator';
import {
    ButtonForm,
    BulletColor,
    AlertModalHeading,
    AlertModalSubHeading,
    AlertContextText,
    AlertModalOptions,
    HorizontalDivider,
    Container,
    AlertModalName,
    ModalBody
} from './AlertModal.styles';

const t = getTranslator(alertModalTranslations);

const AlertModal: FC<{
    isShowing: boolean;
    close: () => void;
}> = ({ isShowing, close }) => {
    return (
        <ModalBody isShowing={isShowing} close={close}>
            <Container>
                <HorizontalDivider variant="horizontal" />
                <AlertModalHeading size="5">
                    {t('alertModal.areaSection.heading')}
                </AlertModalHeading>
                <BulletColor>
                    <li>
                        {t('alertModal.areaSection.areaDetails.flats_for_sale')}
                    </li>
                    <li>
                        {t('alertModal.areaSection.areaDetails.between_price')}
                    </li>
                    <li>
                        {t(
                            'alertModal.areaSection.areaDetails.between_bedrooms'
                        )}
                    </li>
                </BulletColor>
                <AlertModalSubHeading size="7">
                    {t('alertModal.setTheFrequencySection.heading')}
                </AlertModalSubHeading>
                <AlertContextText size="secondary" color="grey-slate">
                    {t('alertModal.setTheFrequencySection.newPropertyAlert')}
                </AlertContextText>
                <AlertModalOptions
                    id="boxed-option-1"
                    label={t(
                        'alertModal.setTheFrequencySection.alertOptions.noEmailAlerts'
                    )}
                    name="boxed-option"
                    variant="boxed"
                />
                <AlertModalOptions
                    id="boxed-option-2"
                    label={t(
                        'alertModal.setTheFrequencySection.alertOptions.instant'
                    )}
                    name="boxed-option"
                    variant="boxed"
                />

                <AlertModalOptions
                    id="boxed-option-3"
                    label={t(
                        'alertModal.setTheFrequencySection.alertOptions.daily'
                    )}
                    name="boxed-option"
                    variant="boxed"
                />

                <AlertModalOptions
                    id="boxed-option-4"
                    label={t(
                        'alertModal.setTheFrequencySection.alertOptions.everyThreeDays'
                    )}
                    name="boxed-option"
                    variant="boxed"
                />

                <AlertModalOptions
                    id="boxed-option-5"
                    label={t(
                        'alertModal.setTheFrequencySection.alertOptions.weekly'
                    )}
                    name="boxed-option"
                    variant="boxed"
                />

                <Text size="small" color="grey-steel">
                    {t('alertModal.setTheFrequencySection.adjustFrequency')}
                </Text>

                <AlertModalSubHeading size="7">
                    {t('alertModal.manageAlertsSection.heading')}
                </AlertModalSubHeading>

                <AlertModalName
                    id="field-nickname"
                    label={t('alertModal.manageAlertsSection.alertNickname')}
                    name="name-nickname"
                />

                <ButtonForm variant="primary">
                    {t('alertModal.saveButton')}
                </ButtonForm>
            </Container>
        </ModalBody>
    );
};

export default AlertModal;
